// extracted by mini-css-extract-plugin
module.exports = {"amountContainer":"Qfo0O6Ys","accountsContainer":"_1N2kYaA5"};